// extracted by mini-css-extract-plugin
export default {"AccountTypeList":"AccountTypeList_AccountTypeList__jfjNk"};